import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { FormikTouched } from "formik";
import { FormikErrors } from "formik/dist/types";
import { FunctionComponent, h } from "preact";
import { fields, InsufficientCover, SolarDiverterForm } from "../form";

export const CoverTypeSelect: FunctionComponent<{
  form: {
    handleChange: any;
    values: Record<keyof SolarDiverterForm, any>;
    touched: FormikTouched<SolarDiverterForm>;
    errors: FormikErrors<SolarDiverterForm>;
  };
}> = ({ form }) => {
  const fieldData = fields.find(({ id }) => id === "insufficientCoverType");
  if (!fieldData) {
    throw new Error("Cannot find insufficient cover type field");
  }
  return (
    <FormControl fullWidth sx={{ mb: 1 }}>
      <InputLabel id="cover-type-label">{fieldData.label}</InputLabel>
      <Select
        labelId="cover-type-label"
        label={fieldData.label}
        id={fieldData.id}
        value={form.values.insufficientCoverType}
        name={fieldData.id}
        onChange={form.handleChange}
        error={
          form.touched.insufficientCoverType &&
          Boolean(form.errors.insufficientCoverType)
        }
      >
        <MenuItem value={InsufficientCover.Gas}>Gas</MenuItem>
        <MenuItem value={InsufficientCover.Electricity}>Electricity</MenuItem>
      </Select>
    </FormControl>
  );
};
